import { use as m, insert as s, createComponent as l, mergeProps as p, effect as u, className as c, style as f, setAttribute as d, template as g } from "solid-js/web";
import y from "../SelectorTwoTop/index.js";
import b from "../SelectorTwoArea/index.js";
import { cn as v } from "../../utils/class.js";
var A = g("<div data-scope=date-picker data-type=date-selector-wrapper data-part=grid>");
const N = { option: () => 0, setOption: () => {
}, optionsArray: [] }, x = (e) => {
  return r = A(), typeof (t = e.ref) == "function" ? m(t, r) : e.ref = r, s(r, l(y, p(e, { get isYear() {
    return e.useValueAsName;
  } })), null), s(r, l(b, p(e, { get yearArray() {
    return e.yearArray;
  } })), null), u((a) => {
    var n = v(`
        date-selector-wrapper
        rn-absolute
        rn-left-0
        rn-top-0
        rn-z-50
       
        rn-max-h-fit
        rn-w-full
        rn-rounded-md 
        rn-bg-white 
        rn-pb-[0.5rem]
        rn-pt-[0.625rem] 
        rn-shadow-lg
        dark:rn-bg-dreamless-sleep 
      `, e.monthYearSelectorWrapperClass), i = { ...e.backgroundColor && { "background-color": e.backgroundColor } }, o = e.useValueAsName ? "select year" : "select month";
    return n !== a.e && c(r, a.e = n), a.t = f(r, i, a.t), o !== a.a && d(r, "aria-roledescription", a.a = o), a;
  }, { e: void 0, t: void 0, a: void 0 }), r;
  var r, t;
};
export {
  x as default,
  N as defaultSelectorProps
};
